import tomPic from "@/public/images/artists/tom.png";
import { Artist } from "@/types/types";

export const tom = {
  id: "13",
  name: "Tom",
  image: tomPic,
  description: `Tom infuses his songs with raw emotion and vulnerability. His distinct rasp adds a unique texture to his voice and his vocals effortlessly range from intimate ballads to anthemic choruses.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftom-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Blues",
        "RnB",
        "Soul",
        "Pop",
        "Dance",
        "Airy",
        "Falsetto",
        "Deep",
      ],
      secondary: ["Singer"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 48,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
